import * as React from 'react';
import { registerDecorator } from '@avensia/excite-contentful/Document';
import { styled } from '@glitz/react';
import { createMaxSmallViewportDecorator } from 'webapp/viewport';

registerDecorator<Excite.Contentful.ListApiModel>(
  'ul',
  styled(({ children }) => <Ul>{children}</Ul>),
);

registerDecorator<Excite.Contentful.ListApiModel>(
  'ol',
  styled(({ children }) => <Ol>{children}</Ol>),
);

const ListStyle = styled(
  createMaxSmallViewportDecorator({
    marginBottom: t => t.spacing.l,
  }),
  {
    margin: {
      bottom: t => t.spacing.xl,
    },
    fontSize: t => t.fontSize.xs,
    lineHeight: t => 24 / t.fontSize.xs,
  },
);

const Ul = styled.ul(ListStyle);

const Ol = styled.ol(ListStyle);
